/**
 * Mock-program mode: render a step for a program that does not exist.
 *
 * The MySheerID theme builder previews a program's branding before a program has been created, so
 * there is no programId to fetch a verification or a theme with. In this mode the verification
 * response comes from `serverMocks/mocks` and the theme from `serverMocks/mockProgramTheme`, and
 * jslib makes no calls to the verification service at all.
 *
 * This is deliberately separate from the ordinary `programBuilderPreview` install type, which still
 * previews a *real* program by id and must keep fetching. Declared by `renderMockProgram` in the
 * `_mysheerid-preview` bundle, in the same spirit as `setInstallType`.
 */
let mockProgramEnabled = false;

export const enableMockProgram = (): void => {
  mockProgramEnabled = true;
};

export const disableMockProgram = (): void => {
  mockProgramEnabled = false;
};

export const isMockProgram = (): boolean => mockProgramEnabled;
